import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";

export default function ProtectedRoute({ children, role }) {
  const { user, loading } = useAuth();
  const location = useLocation();
  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-stone2-50" data-testid="auth-loading">
        <div className="text-sage-700 text-sm">Loading...</div>
      </div>
    );
  }
  if (!user) return <Navigate to="/login" replace />;
  // Force any user with must_change_password to set their own before continuing
  if (user.must_change_password && location.pathname !== "/change-password-required") {
    return <Navigate to="/change-password-required" replace />;
  }
  // Admins may impersonate a family/sitter to fill in profile details on their behalf.
  // Bypass the role gate only when the URL carries `?admin_edit=<userId>`.
  const isAdminEditImpersonation = user.role === "admin" && new URLSearchParams(location.search).has("admin_edit");
  if (role && user.role !== role && !isAdminEditImpersonation) return <Navigate to="/" replace />;
  return children;
}
